






















































import { ClientAccountMessageHistory } from '@/shared/clients/client-account-message-history';
import { MessageType } from '@/shared/message-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ViewMessageDialog extends Vue {
    @Prop({ required: true }) private message!: ClientAccountMessageHistory;
    @Prop({ required: true }) private visible!: boolean;

    private isVisible: boolean = this.visible;

    private get messageTypeDescription(): string {
        switch (this.message.type!) {
            case MessageType.AppointmentConfirmation:
                return 'Appointment Confirmation';
            case MessageType.AppointmentReminder:
                return 'Appointment Reminder';
            case MessageType.AppointmentLookingForwardToSeeingYou:
                return 'Appointment LFTSY';
            default:
                return '';
        }
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
